import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <section className="pt-32 pb-24 bg-background-50 min-h-[70vh] flex items-center">
        <div className="max-w-2xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-primary-100 text-primary-700 mb-6">
            <i className="ri-error-warning-line w-7 h-7 flex items-center justify-center text-3xl" />
          </div>
          <h1 className="text-4xl md:text-6xl font-heading font-extrabold text-foreground-950">
            404
          </h1>
          <p className="mt-3 text-base md:text-lg text-foreground-700">
            요청하신 페이지를 찾을 수 없습니다.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-600 hover:bg-primary-700 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line w-4 h-4 flex items-center justify-center" />
              HOME으로 이동
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-background-100 hover:bg-background-200 text-foreground-900 font-semibold text-sm whitespace-nowrap cursor-pointer"
            >
              문의하기
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}